/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title:  mall.ts
 * @Package :
 * @author:飞算科技
 * @date:   2022/1/19 11:30
 * @version V1.0
 * @Copyright: 2020 https://www.feisuan.com Inc. All rights reserved.
 * @Belong To: 飞算科技
 * 注意：本内容仅限于飞算数智科技（深圳）有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */

/* 企业商城模块 */
const mallRouter = [
  {
    path: '/shop',
    name: 'Shop',
    component: () =>
      import(
        /* webpackChunkName: "mall" */ '@/views/goodsManage/mall/shop/Index.vue'
      ),
    meta: {
      title: '供应商',
      keepAlive: true,
      deepth: 1,
      permission: true,
    },
  },
  {
    path: '/buyCar',
    name: 'buyCar',
    component: () =>
      import(
        /* webpackChunkName: "mall" */ '@/views/goodsManage/mall/buyCar/Index.vue'
      ),
    meta: {
      title: '购物车',
      // keepAlive: true,
      deepth: 1,
      permission: true,
    },
  },
  {
    path: '/searchHistory',
    name: 'SearchHistory',
    component: () =>
      import(
        /* webpackChunkName: "mall" */ '@/views/goodsManage/mall/shop/SearchHistory.vue'
      ),
    meta: {
      title: '搜索历史',
      deepth: 3,
    },
  },
  {
    path: '/searchShop',
    name: 'SearchShop',
    component: () =>
      import(
        /* webpackChunkName: "mall" */ '@/views/goodsManage/mall/shop/SearchShop.vue'
      ),
    meta: {
      title: '搜索店铺',
      deepth: 3,
    },
  },
  {
    path: '/storeHome', // 供应商进去店铺页面
    name: 'storeHome',
    component: () =>
      import(
        /* webpackChunkName: "mall" */ '@/views/goodsManage/mall/shop/ShopHome.vue'
      ),
    meta: {
      title: '进入店铺',
      keepAlive: true,
      deepth: 4,
    },
  },
  {
    path: '/searchGoods',
    name: 'SearchGoods',
    component: () =>
      import(
        /* webpackChunkName: "mall" */ '@/views/goodsManage/mall/shop/SearchGoods.vue'
      ),
    meta: {
      title: '商品搜索结果',
      deepth: 5,
    },
  },
  {
    path: '/favorites',
    name: 'Favorites',
    component: () =>
      import(
        /* webpackChunkName: "mall" */ '@/views/goodsManage/mall/shop/Favorites.vue'
      ),
    meta: {
      title: '收藏夹',
      keepAlive: true,
      deepth: 5,
    },
  },
  {
    path: '/goodsClass',
    name: 'GoodsClass',
    component: () =>
      import(
        /* webpackChunkName: "mall" */ '@/views/goodsManage/mall/shop/GoodsClass.vue'
      ),
    meta: {
      title: '商品分类',
      keepAlive: true,
      deepth: 5,
    },
  },
  {
    path: '/newArrivals',
    name: 'NewArrivals',
    component: () =>
      import(
        /* webpackChunkName: "mall" */ '@/views/goodsManage/mall/shop/NewArrivals.vue'
      ),
    meta: {
      title: '新品上架',
      keepAlive: true,
      deepth: 5,
    },
  },
  {
    path: '/hotSale',
    name: 'HotSale',
    component: () =>
      import(
        /* webpackChunkName: "mall" */ '@/views/goodsManage/mall/shop/HotSale.vue'
      ),
    meta: {
      title: '热卖推荐',
      keepAlive: true,
      deepth: 5,
    },
  },
  {
    path: '/shopBarCodeGoods',
    name: 'ShopBarCodeGoods',
    component: () =>
      import(
        /* webpackChunkName: "mall" */ '@/views/goodsManage/mall/shop/ShopBarCodeGoods.vue'
      ),
    meta: {
      title: '扫码下单',
      keepAlive: true,
      deepth: 5,
    },
  },
  {
    path: '/goodsDetail',
    name: 'GoodsDetail',
    component: () =>
      import(
        /* webpackChunkName: "mall" */ '@/views/goodsManage/mall/shop/GoodsDetail.vue'
      ),
    meta: {
      title: '商品详情',
      deepth: 6,
    },
  },
  {
    path: '/submitOrder',
    name: 'SubmitOrder',
    component: () =>
      import(
        /* webpackChunkName: "mall" */ '@/views/goodsManage/mall/buyCar/SubmitOrder.vue'
      ),
    meta: {
      title: '提交订单',
      keepAlive: true,
      deepth: 7,
    },
  },
  {
    path: '/merchBill',
    name: 'MerchBill',
    component: () =>
      import(
        /* webpackChunkName: "mall" */ '@/views/goodsManage/mall/buyCar/MerchBill.vue'
      ),
    meta: {
      title: '商品套餐清单',
      deepth: 8,
    },
  },
  {
    path: '/submitSuccess',
    name: 'SubmitSuccess',
    component: () =>
      import(
        /* webpackChunkName: "mall" */ '@/views/goodsManage/mall/buyCar/SubmitSuccess.vue'
      ),
    meta: {
      title: '订单提交成功',
      deepth: 1,
    },
  },
  {
    path: '/shopLevelSetting',
    name: 'ShopLevelSetting',
    component: () =>
      import(
        /* webpackChunkName: "customer" */ '@/views/customerManage/level/LevelSetting.vue'
      ),
    meta: {
      title: '客户级别设置',
      deepth: 2,
      permission: true,
    },
  },
  {
    path: '/shopLabelSetting',
    name: 'ShopLabelSetting',
    component: () =>
      import(
        /* webpackChunkName: "customer" */ '@/views/customerManage/label/LabelSetting.vue'
      ),
    meta: {
      title: '客户标签设置',
      deepth: 2,
      permission: true,
    },
  },
  {
    path: '/shopGroupSetting',
    name: 'ShopGroupSetting',
    component: () =>
      import(
        /* webpackChunkName: "customer" */ '@/views/customerManage/group/GroupSetting.vue'
      ),
    meta: {
      title: '客户分组设置',
      deepth: 2,
      permission: true,
    },
  },
  {
    path: '/tabbar-more',
    name: 'tabbar-more',
    component: () =>
      import(
        /* webpackChunkName: "customer" */ '@/layouts/tabbar-more/more.vue'
      ),
    meta: {
      title: '更多',
      permission: true,
    },
  },
];

export default mallRouter;
